import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="mx-auto flex w-full max-w-[1280px] flex-1 flex-col items-center justify-center px-4 py-24 text-center">
        <p className="font-display text-[100px] leading-none text-background-300 md:text-[160px]">404</p>
        <h1 className="mt-4 text-2xl font-bold text-foreground-50">页面走丢了</h1>
        <p className="mt-3 text-sm text-foreground-400">
          你访问的页面不存在或已被移除，不妨回到首页继续发现好电影。
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-accent-500 px-6 py-2.5 text-sm font-medium text-background-950 transition hover:bg-accent-400"
          >
            返回首页
          </Link>
          <Link
            to="/news"
            className="whitespace-nowrap rounded-md border border-background-300/70 px-6 py-2.5 text-sm text-foreground-100 transition hover:border-accent-500/70 hover:text-accent-400"
          >
            查看电影资讯
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}